<template>
  <teleport to="body">
    <div
      v-if="draging"
      class="auxiliary-line"
      :style="{ top: `${top}px`, width: lineWidth, left: lineLeft }"
    ></div>
  </teleport>
</template>
<script setup lang="ts">
  import { computed } from 'vue'
  import { useLayout } from '@haohan/clw-platform-public'
  const layoutStore = useLayout()
  interface Props {
    draging: boolean
    top: number
  }
  const props = withDefaults(defineProps<Props>(), {
    draging: false,
    top: 0
  })
  // 辅助线宽度设置
  const lineWidth = computed(() => {
    return `calc(100vw - ${layoutStore.funWidth}px)`
  })
  const lineLeft = computed(() => {
    return `${54 + (layoutStore.leftFunIsOpen ? 300 : 0)}px`
  })
</script>
<style lang="scss" scoped>
  .auxiliary-line {
    height: 1px;
    // 30得偏移量是减去滚动条得宽度，避免出现横向滚动条
    width: calc(100vw - 30px);
    background-color: var(--bg-color-primary);
    position: absolute;
    z-index: 0;
    bottom: 0;
  }
</style>
